
import { Modal } from 'antd';
import React from 'react';
import Icon from 'component/Icon';
import styles from './index.module.scss';
import { MeetingIotMsg } from 'type/meeting';

interface IProps {
  show: boolean
  onClose: () => void
  iotMessage: MeetingIotMsg[]
}
const IotModal: React.FC<IProps> = ({
  show,
  onClose,
  iotMessage
}) => {
  return (
    <>
    <Modal
      className={styles.iot}
      forceRender
      visible={show}
      width={400}
      closable={false}
      onCancel={onClose}
      footer={null}
      centered
      destroyOnClose
    >
      <div className={styles.iotMsg}>
        <div className={styles.iotIcon}>
          <div className={styles.icon}>
            <Icon type='iconpop_success_ic' size={40} color='#487FF8' ></Icon>
          </div>
          <div className={styles.successText}>签到成功</div>
          <div className={styles.roomText}>会议室环境已就绪</div>
        </div>
        <div className={styles.devicesStatus}>
          { iotMessage &&
            iotMessage.map((item) => (
              <div className={styles.devicesTip} key={item.deviceName}>
                <div className={styles.title}>{item.deviceName}</div>
                <div className={styles.statusText}>
                  {item.deviceStatus === 0 && <div className={styles.status}>
                    <div className={styles.status_icon + ' ' + styles.close}></div>
                    <div>已关闭</div>
                    </div> }
                  {item.deviceStatus === 1 && <div className={styles.status}>
                    <div className={styles.status_icon + ' ' + styles.open}></div>
                    <div>已开启</div>
                    </div> }
                  {item.deviceStatus === 2 && <div className={styles.status}>
                    <div className={styles.status_icon + ' ' + styles.error}></div>
                    <div>异常</div>
                    </div> }
                </div>
              </div>
            ))
          }
        </div>
        <div className={styles.footer}>联系管理员：400-168-9545</div>
     </div>
    </Modal>
    </>
  );
};

export default IotModal;
